export const AUTO_OPEN_CONTACT_FORM_PARAM = "open-contact-form" as const;
export const AUTO_OPEN_CONTACT_FORM_VALUE = "yes" as const;
export const THEME_COLOR = "#f0ece7" as const;
export const constants = {
        "thelabui.fields.week.Weekday": {
            "MONDAY": 1,
            "TUESDAY": 2,
            "WEDNESDAY": 3,
            "THURSDAY": 4,
            "FRIDAY": 5,
            "SATURDAY": 6,
            "SUNDAY": 7
        },
        "server.cms.blocks.featured_rich_text.BlockLayouts": {
            "left": "left",
            "center": "center",
            "right": "right"
        },
        "server.cms.blocks.svg.ClientSvgs": {
            "BROOKLINEN": "client-brooklinen",
            "DEVACURL": "client-devacurl",
            "DOUGLASELLIMAN": "client-douglaselliman",
            "FORTUNEBRANDS": "client-fortunebrands",
            "FRITOLAY": "client-fritolay",
            "HYUNDAI": "client-hyundai",
            "KENTUCKYLEGEND": "client-kentuckylegend",
            "LAAURORA": "client-laaurora",
            "PERNODRICARD": "client-pernodricard",
            "QDOBA": "client-qdoba",
            "SKS": "client-sks",
            "SUPERNAL": "client-supernal",
            "TEMPURPEDIC": "client-tempurpedic",
            "VISTAPRINT": "client-vistaprint",
            "YAMAZAKI": "client-yamazaki"
        },
        "server.cms.forms.ContactReason": {
            "GENERAL": "GENERAL",
            "BUSINESS": "BUSINESS",
            "MEDIA": "MEDIA",
            "JOBS": "JOBS"
        },
        "server.cms.models.pages.base_page.BackgroundThemeChoices": {
            "CREAM": "cream",
            "BLACK": "black",
            "DARKGRAY": "darkGray",
            "MIDGRAY": "midGray",
            "LIGHTGRAY": "lightGray",
            "COOLGRAY": "coolGray"
        },
        "AUTO_OPEN_CONTACT_FORM_PARAM": "open-contact-form",
        "AUTO_OPEN_CONTACT_FORM_VALUE": "yes",
        "server.cms.blocks.case_study_grid.WorkTypes": {
            "marketing": "marketing",
            "website": "website",
            "content": "content"
        },
        "THEME_COLOR": "#f0ece7"
    } as const;
